import { YOUR_PRIVACY_SETTINGS_PATH } from 'utils/constants/urls';

const isBrowser = typeof window !== 'undefined';

const isPwnHealthPage = (): boolean => {
  if (!isBrowser) return false;
  return Boolean((window as any).isPwnHealthPage);
};

export const isEmbeddedPage = (): boolean => {
  if (!isBrowser) return false;

  if ((window as any).embedded) return true;

  if (
    typeof navigator !== 'undefined' &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('com.everlyhealth.ios') !== -1
  ) {
    return true;
  }

  try {
    if (sessionStorage.getItem('embedded') === 'true') return true;
  } catch {
    // sessionStorage can throw in restricted contexts; treat as not embedded.
  }

  return false;
};

const normalizePathname = (pathname: string): string => {
  if (!pathname) return '/';
  return pathname.startsWith('/') ? pathname : `/${pathname}`;
};

const isExcludedByPrefix = (pathname: string, prefix: string): boolean =>
  normalizePathname(pathname).startsWith(prefix);

export const EVA_CONFIG = {
  agentId: (process.env.GATSBY_EVA_AGENT_ID ?? '').trim(),
  enabled: process.env.GATSBY_EVA_ENABLED === 'true',
  conversationTTL: 24 * 60 * 60 * 1000, // 24 hours
  maxMessages: 100,
  maxStoredPages: 50,
  maxStoredQueries: 20,
  excludedRoutes: [
    '/checkout/',
    '/quest-checkout/',
    '/weightloss-checkout/',
    '/everlywell-weightloss/',
    '/wcplus-confirmation/',
    '/gotmytest/',
    '/humana-welcome-kit/',
    '/welcome-kit/',
    '/everlywell-360-quiz',
    '/terms-of-use/',
    '/consumer-health-data-privacy-notice/',
    '/privacy-policy/',
    YOUR_PRIVACY_SETTINGS_PATH,
    '/members/consentandnotice/',
  ],
  isRouteExcluded: (pathname: string): boolean => {
    if (isPwnHealthPage()) return true;

    const normalized = normalizePathname(pathname);
    if (normalized === '/everlywell-360-quiz') return true;

    return (
      isExcludedByPrefix(normalized, '/checkout/') ||
      isExcludedByPrefix(normalized, '/quest-checkout/') ||
      isExcludedByPrefix(normalized, '/weightloss-checkout/') ||
      isExcludedByPrefix(normalized, '/everlywell-weightloss/') ||
      isExcludedByPrefix(normalized, '/wcplus-confirmation/') ||
      isExcludedByPrefix(normalized, '/humana-welcome-kit/') ||
      isExcludedByPrefix(normalized, '/welcome-kit/') ||
      isExcludedByPrefix(normalized, '/gotmytest/')
    );
  },
} as const;

export const isEvaEnabled = (): boolean =>
  EVA_CONFIG.enabled && !isPwnHealthPage();

export const isEvaConfigured = (): boolean =>
  isEvaEnabled() && EVA_CONFIG.agentId.length > 0;
